import React from 'react';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import PropTypes from 'prop-types';

function BackButton () {
  const handleButtonClick = () => {
    window.location = "#/myaccount";
  };

  return (
    <IconButton aria-label="back" class="backBtn" onClick={handleButtonClick}>
      <ArrowBackIcon />Retour
    </IconButton>
  );
};

export default BackButton;
// BackButton.propTypes = {
//   btnClick: PropTypes.func.isRequired,
// };
